<script>
export default {
  props: {
    text: { default: 'BTNTEXT', type: String },
    path: { default: '' },
    icon: { default: '', type: String },
    selected: { default: false, type: Boolean },
    dropdown: {}
  },
  computed: {
    indicatorClass() {
      return {
        buttonIndicator: true,
        selected: this.selected
      }
    }
  }
}
</script>

<template>
  <div class="header-button">
    <div :class="indicatorClass"></div>
    <b-dropdown
      v-if="typeof dropdown != 'undefined'"
      no-caret
      variant="link"
      toggle-class="text-decoration-none"
      class="header-dropdown"
    >
      <template slot="button-content">
        <span v-if="icon != ''" class="button-icon">
          <font-awesome-icon :icon="icon" />
        </span>
        <span>{{ text }}</span>
      </template>
      <b-dropdown-item
        v-for="(entry, key) in dropdown"
        :key="key"
        :class="{ selected: entry.selected }"
        :to="typeof entry.path == 'object' ? entry.path : { name: entry.path }"
        >{{ entry.text }}</b-dropdown-item
      >
    </b-dropdown>
    <router-link :to="typeof path == 'object' ? path : { name: path }" v-else>
      <span v-if="icon != ''" class="button-icon">
        <font-awesome-icon :icon="icon" />
      </span>
      <span>{{ text }}</span>
    </router-link>
  </div>
</template>

<style>
.header-button {
  color: #194173;
  /*font-family: "Proxima Nova";*/
  font-size: 1.2em;
  /*letter-spacing: 2px;*/
  line-height: 80px;
  height: 100px;
  text-align: center;
}
.header-button a:link,
.header-button a:visited {
  color: #194173;
  text-decoration: none;
  font-weight: lighter;
}
.header-button a:hover {
  text-decoration: underline;
}
.buttonIndicator {
  position: relative;
  height: 13px;
  top: -13px;
  width: 100%;
}
.header-button .selected {
  background-color: #666;
}
.button-icon {
  margin-right: 5px;
}
.header-dropdown,
.header-dropdown * {
  color: #194173;
}
.header-dropdown {
  font-size: 1.2em;
}
.header-dropdown .selected:not(:hover) * {
  color: #fff;
}
.header-dropdown .dropdown-item {
  line-height: initial;
  width: 100%;
}
</style>
